import { SITE_ORIGIN } from "@/lib/siteOrigin";

/** Consistent route-level social and search metadata for SSR. */
export function routeHead(title: string, description: string, path?: string) {
  const url = path ? `${SITE_ORIGIN}${path}` : undefined;
  return {
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      ...(url ? [{ property: "og:url", content: url }] : []),
    ],
    ...(url ? { links: [{ rel: "canonical", href: url }] } : {}),
  };
}
